import React from 'react'
import { ListItemText, Typography } from '@mui/material'
import { StyledListItemButton, StyledListItemIcon } from '../../styles/SidebarStyles'
import { useAppSelector } from '../../store/redux/hooks'
import { ArrowForward } from '@mui/icons-material'
import { PopupState } from 'material-ui-popup-state/hooks'
import { useNavigate } from 'react-router-dom'

type SidebarLinkProps = {
  text: string
  route: string
  index: number
  popupState: PopupState
}

const MenuSidebarLink = ({ text, route, index, popupState }: SidebarLinkProps) => {
  const pageIndex = useAppSelector(state => state.pageName.index)
  const navigate = useNavigate()

  const handleClick = (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    navigate(route)
    popupState.close()
  }

  return (
    <StyledListItemButton
      sx={{ ml: 0, width: 'auto', px: 1, gap: 1 }}
      selected={index === pageIndex}
      onClick={handleClick}
    >
      <ListItemText>
        <Typography variant="body2" fontSize={12} fontWeight={400} ml={0.5} noWrap>
          {text}
        </Typography>
      </ListItemText>
      <StyledListItemIcon>
        <ArrowForward sx={{ width: 16 }} />
      </StyledListItemIcon>
    </StyledListItemButton>
  )
}

export default MenuSidebarLink
